/**
 * sim_type（task_type.sim_type / scene_category.sim_type）→ 展示名与 Tag 色标。
 *
 * 全站一处收敛：后台管理「任务类型 / 场景类型」表格、任务对比页「对比双方基本信息」
 * 共用这份映射，避免各页各写一份导致文案/配色漂移。
 * 值域与后端 ``api/schemas/task_type.py`` 的 SimType Literal 白名单一致。
 */
import type { SimType } from '@apis/simulation';

export const SIM_TYPE_LABELS: Record<SimType, string> = {
  planning: 'PNC 仿真',
  perception: '感知仿真',
  map: '地图仿真',
  hil: 'HIL 仿真',
  other: '其他',
};

/** antd Tag 色标；与左栏仿真分组、后台管理表格一致 */
export const SIM_TYPE_COLORS: Record<SimType, string> = {
  planning: 'geekblue',
  perception: 'green',
  map: 'orange',
  hil: 'purple',
  other: 'default',
};

/** 未登记值原样回显（便于后端新增 sim_type 时前端不至于显示空白） */
export const simTypeLabel = (v?: SimType | string | null): string =>
  (v && SIM_TYPE_LABELS[v as SimType]) || v || '-';

export const simTypeColor = (v?: SimType | string | null): string =>
  (v && SIM_TYPE_COLORS[v as SimType]) || 'default';
